<template>
  <div class="d-flex flex-row">
    <div v-if="getGlobalValue('VEC_INCLUDES_OLI_PREFILL')=='true'" class="d-flex flex-row flex-wrap" style="width: 100%;">
      <div v-for="(listItem,index) in prefillList" :key="index" class="mr-3 mb-2">
        <v-chip @click="enterText(listItem.text)" :color="listItem.color||'info'">{{ listItem.text }}</v-chip>
      </div>
    </div>
    <div v-else>Global not enabled.</div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'DynamicTextPrefills',
  props: {
    containerId: String,
    data: Object,
  },
  computed: {
    ...mapGetters([
      'getEndpoint',
      'getUser',
      'getGlobalValue'
    ]),
  },
  data: () => ({
    prefillList: [],
    btnLoaders: [],
    mainLoader: true,
    snackObj: {
      text: '',
      state: false,
      color: ''
    },
    outlined: false,
    card: false,
    visibleTo: "",
    show: false,
  }),
  async mounted(){
    try {
      let arr = this.getGlobalValue("VEC_OLI_PREFILL_LIST").split("\n")
      let temp = []
      for(let i of arr){
        temp.push({color: "info", text: i})
      }
      
      this.prefillList = temp
    } catch (error) {
      console.log(error.msg || error)
    }
  },
  methods: {
    async enterText(text){
      let res = (this.data.item ? this.data.item+ ", " : "") + text
      this.$emit('cb', res, this.data.id1)
    }
  }
}
</script>
